<template>
    <div>
        <CreateAccount
            :uuid="uuid"
            :last-name="summary.lastName"
            :first-name="summary.firstName"
            :location-id="summary.locationId"
            :account-created="summary.accountCreated"
            :account-id="summary.id? summary.id.replace(/#/g, ''): null"
            :is-mobile-eligible="summary.mobileEligible"
            :is-mobile-interested="summary.mobileInterested"
        />
        <AccountInfo
            :is-mobile-eligible="summary.mobileEligible"
            :is-mobile-interested="summary.mobileInterested"
            :summary="summary"
            :firstName="firstName"
            :is-gwp="isGwp"
        />
        <ServicesInfo
            :is-fmf="isFmf"
            :add-ons="addOns"
            :services="services"
            :is-gwp="isGwp"
            :gwp-amount="gwpAmount"
            :fmf-amount="fmfAmount"
            :has-hbo-max="hasHboMax"
            :service-types="serviceTypes"
        />
        <InstallationInfo
            :is-tech-delivered="isTechDelivered"
            :format-install-date="formatInstallDate"
            :is-equipment-selected="isEquipmentSelected"
            :has-selected-self-install="hasSelectedSelfInstall"
        />

        <PromoInfo
            v-if="hasGiftCard"
        />

        <StatementInfo
            :cart-data="cartData"
            :fmf-amount="fmfAmount"
            :discount-amount="discountAmount"
        />

    </div>
</template>

<script>
    import CreateAccount from "./createAccount"
    import AccountInfo from "./accountInfo"
    import ServicesInfo from "./servicesInfo";
    import StatementInfo from "./statementInfo";
    import InstallationInfo from "./installationInfo";
    import PromoInfo from "./promoInfo.vue";

    export default {
        name: 'SummaryLot',
        components: {
			CreateAccount,
            AccountInfo,
            ServicesInfo,
            StatementInfo,
            InstallationInfo,
            PromoInfo,
        },
        props: {
            summary:  {
                type: Object,
                required: true,
            },
            cartData: {
                type: Object,
                required: true,
            },
            firstName: {
                type: String,
                default: '',
            },
            formatInstallDate: {
                type: String,
                default: null,
            },
            hasSelectedSelfInstall: {
                type: Boolean,
                default: false,
            },
            isWowMarket: {
                type: Boolean,
                default: false,
            },
            isFmf: {
                type: Boolean,
                default: false,
            },
            fmfAmount: {
                type: Number,
                default: 0,
            },
            isGwp: {
                type: Boolean,
                default: false,
            },
            gwpAmount: {
                type: String,
                default: '$0',
            },
            discountAmount: {
                type: Number,
                default: 0,
            },
            isEquipmentSelected: {
                type: Function,
                default: false,
            },
            isFiber: {
                type: Boolean,
                default: false,
            },
            isTechDelivered: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            serviceTypes() {
                // filtering the services and addOns to only return the ones that have a length greater than 0
                const services = Object.entries(this.services || {}).filter(v => typeof v[1] === 'object' && v[1]?.length > 0).map(i => i[0])
                const addOns = Object.entries(this.addOns || {}).filter(v => typeof v[1] === 'object' && (v[1].hasOwnProperty('base') && v[1].base?.length > 0 || (v[1].hasOwnProperty('equipment') && v[1].equipment?.length > 0))).map(i => i[0])
                return [
                    ...new Set([
                        ...services,
                        ...addOns,
                    ])
                ]
            },
            services() {
                return this.cartData.services
            },
            addOns() {
                return this.cartData.addOns
            },
            hasHboMax() {
                return this.cartData.addOns?.tv?.packages?.findIndex(p => p?.name?.includes('HBO Max')) >= 0
            },
            hasGiftCard() {
                return this.addOns?.promo?.giftCard?.length > 0;
            },
            uuid() {
				const urlParams = new URLSearchParams(window.location.search)
                return urlParams.get('uuid') ?? null
            },
        }
    }
</script>
